import { playerOptions, type SampleSectionProps } from './templateEditing';
import { KeyedSelect, SampleFieldset } from './SampleFormControls';

const PAIR_PATH = 'duplicatePairPlayerKeys';

export const DuplicatePairFieldset = ({ value, onChange, errorFor }: SampleSectionProps) => {
  const players = playerOptions(value.players);
  const [first, second] = value.duplicatePairPlayerKeys ?? ['', ''];
  // The pair rule fails on the pair as a whole, so that message sits under the first picker.
  const firstError = errorFor(PAIR_PATH) ?? errorFor(`${PAIR_PATH}[0]`);

  const setPair = (nextFirst: string, nextSecond: string) =>
    onChange({
      ...value,
      duplicatePairPlayerKeys: nextFirst || nextSecond ? [nextFirst, nextSecond] : null,
    });

  return (
    <SampleFieldset
      legend="Duplicate pair"
      hint={
        <p className="sample-form__hint">
          Pick two players with the same name and grad year so Merge Manager finds them.
        </p>
      }
    >
      <div className="sample-form__row-fields">
        <KeyedSelect
          label="First player"
          path={`${PAIR_PATH}[0]`}
          error={firstError}
          testId="sample-data-duplicate-first"
          options={players}
          value={first}
          placeholder="Choose a player"
          clearable
          onChange={(key) => setPair(key, second)}
        />
        <KeyedSelect
          label="Second player"
          path={`${PAIR_PATH}[1]`}
          error={errorFor(`${PAIR_PATH}[1]`)}
          testId="sample-data-duplicate-second"
          options={players}
          value={second}
          placeholder="Choose a player"
          clearable
          onChange={(key) => setPair(first, key)}
        />
      </div>
    </SampleFieldset>
  );
};
